export default __webpack_public_path__ + "static/n5-2e11b1585ce338b43c1f21c58b5e0a4f.jpg";